import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseControlValueAccessor } from '../../../../util/form/BaseControlValueAccessor';
import { getNgValueAccessorProvider } from "../../../../util/form/value-accessor-export-functions";

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ...getNgValueAccessorProvider(SwitcherComponent),
  ],
})
export class SwitcherComponent extends BaseControlValueAccessor<boolean> {
  // eslint-disable-next-line
  @Input('checked') value: boolean = false;
  @Input() disabled = false;
  @Input() leftText: string;
  @Input() rightText: string;
  @Input() noPropagation = false;
  @Input() id: string = undefined;
  @Output() checkedChanged = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  // Keep only the methods where additional logic is needed (e.g., change detection)
  writeValue(value: boolean): void {
    super.writeValue(value);
    this.cdr.markForCheck(); // Additional logic to trigger change detection
  }

  setDisabledState(isDisabled: boolean): void {
    super.setDisabledState(isDisabled);
    this.disabled = isDisabled;
    this.cdr.markForCheck(); // Additional logic to trigger change detection
  }

  onCheckedChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.value = checked;

    this.onModelChange(checked); // Call the base class method to handle change
    this.checkedChanged.emit(checked);

    this.cdr.markForCheck();
  }
}
